import {useEffect} from "react";

export const useLockBodyScroll = (locked: boolean) => {
    useEffect(() => {
        const resetStyle = "";

        if (locked) {
            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

            document.body.style.overflow = "hidden";
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        } else {
            document.body.style.overflow = resetStyle;
            document.body.style.paddingRight = resetStyle;
        }

        return () => {
            document.body.style.overflow = resetStyle;
            document.body.style.paddingRight = resetStyle;
        };
    }, [locked]);
};
import {useEffect} from "react";

export const useLockBodyScroll = (locked: boolean) => {
    useEffect(() => {
        const resetStyle = "";

        if (locked) {
            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

            document.body.style.overflow = "hidden";
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        } else {
            document.body.style.overflow = resetStyle;
            document.body.style.paddingRight = resetStyle;
        }

        return () => {
            document.body.style.overflow = resetStyle;
            document.body.style.paddingRight = resetStyle;
        };
    }, [locked]);
};
